/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hamburger-ui-solid': {
    width: 20,
    height: 14,
    viewBox: '0 0 20 14',
    data: '<path pid="0" d="M1 0h18a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 6h18a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 6h18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2z"/>'
  }
})
